import moment, { Moment } from "moment";
import { ActionIcon } from "PFComponents/action_icon";
import { Inline } from "PFComponents/containers";
import { SyntheticEvent } from "react";

import css from "./chat_message.module.scss";
import { Separator } from "./separator";

type Props = {
  owned: boolean;
  createdAt: Moment;
  profileName?: string;
  profileViewable?: boolean;
  handleDeleteClicked: (event: SyntheticEvent) => void;
  handleProfileClicked: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const MessageInfo = ({
  owned,
  createdAt,
  profileName = "",
  profileViewable = false,
  handleDeleteClicked,
  handleProfileClicked
}: Props) => {
  const createdAtInWords =
    createdAt.diff(moment(), "days") < -1 ? createdAt.fromNow() : createdAt.format("MMM D, h:mm a");

  return (
    <Inline as="small" gap="spacingXs" data-qa-id="message-info" justifyContent="end">
      {!owned && profileViewable && (
        <button className={css.profileLink} onClick={handleProfileClicked}>
          {profileName}
        </button>
      )}
      {!owned && !profileViewable && <span>{profileName}</span>}
      {!owned && <Separator />}
      <span>{createdAtInWords}</span>
      {owned && <Separator />}
      {owned && (
        <ActionIcon
          name="remove"
          size="xs"
          onClick={handleDeleteClicked}
          color="paletteWhite0"
          qaId="chat-message-delete"
        />
      )}
    </Inline>
  );
};
